// Copyright 2024, 2026 - Hewlett Packard Enterprise Company
import {
  CUSTOMER_ID_KEY,
  DEV_ACID_KEY,
  REDIRECT_URI_KEY,
  REDIRECT_SEARCH_PARAMS_KEY,
  DEV_AUTHORITY_URL,
  OIDC_AUTHORITY,
  OIDC_CLIENT_ID,
  PENDING_TENANT_ACID_KEY,
  TENANT_ACID_KEY,
  WORKSPACE_ID_KEY,
  getAuthority,
} from '../constants/authConst';

const CCS_LOGIN_URL = window.indigo.REACT_APP_CCS_LOGIN;
const APP_INSTANCE_ID = window.indigo.REACT_APP_CCS_APP_INSTANCE_ID;

export function isDevEnvAuth() {
  return OIDC_AUTHORITY === DEV_AUTHORITY_URL;
}

export function redirectToGlcpLogin({ workspaceId, deepLinkFlag } = {}) {
  const url = new URL(CCS_LOGIN_URL);
  url.searchParams.set('app', APP_INSTANCE_ID);
  if (deepLinkFlag && workspaceId) {
    url.searchParams.set('workspace_id', workspaceId);
  }
  window.location.replace(url.toString());
}

export function saveRedirectRoute(pathname, search) {
  sessionStorage.setItem(REDIRECT_URI_KEY, pathname);
  sessionStorage.setItem(
    REDIRECT_SEARCH_PARAMS_KEY,
    new URLSearchParams(search).toString(),
  );
}

export function postLoginRedirect(history) {
  const redirectTo = window.sessionStorage.getItem(REDIRECT_URI_KEY) || '/';
  window.sessionStorage.removeItem(REDIRECT_URI_KEY);
  const searchParams =
    window.sessionStorage.getItem(REDIRECT_SEARCH_PARAMS_KEY) || '';
  window.sessionStorage.removeItem(REDIRECT_SEARCH_PARAMS_KEY);

  const newUrl = searchParams ? `${redirectTo}?${searchParams}` : redirectTo;
  history.replace(newUrl);
}

function sessionKeyStore() {
  let sessionKey = '';
  return {
    get: () => sessionKey,
    set: key => {
      if (sessionKey === '') {
        sessionKey = key;
      }
    },
  };
}

export const sessionKey = sessionKeyStore();

export function getOidcSessionKey() {
  const workspaceId = localStorage.getItem(WORKSPACE_ID_KEY) || undefined;
  if (!workspaceId && !isDevEnvAuth()) {
    return null;
  }
  return `oidc.user:${getAuthority(workspaceId)}:${OIDC_CLIENT_ID}`;
}

export function clearAuthStorage() {
  localStorage.removeItem(WORKSPACE_ID_KEY);
  localStorage.removeItem(CUSTOMER_ID_KEY);
  if (isDevEnvAuth()) {
    localStorage.removeItem(DEV_ACID_KEY);
  }
  localStorage.removeItem(TENANT_ACID_KEY);
  localStorage.removeItem(PENDING_TENANT_ACID_KEY);

  sessionStorage.removeItem(REDIRECT_URI_KEY);
  sessionStorage.removeItem(REDIRECT_SEARCH_PARAMS_KEY);
}
